import './module/animation';
import { Utils } from './module/utils';
import { initAccordion } from './module/accordion';
import { initFvSlider, initPropertySliders, initConsultantSlider } from './module/slider';
import { initHeaderVisibility, initSmoothScroll, initCtaPopup } from './module/scroll';
import { initTableRowHeight } from './module/table';
import './module/blog';
import './module/background-animation-lib';
import './module/background-animation';
import './module/header';
import { initFormValidationControl } from './module/form';

// ================================================================
// 初期化処理
// ================================================================

// -----------------------------------------------
// DOMロードイベント
// -----------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  try {
    // ビューポート切り替え
    Utils.switchViewport(376, 390);

    // 各機能の初期化
    initCtaPopup();
    initHeaderVisibility();
    initSmoothScroll();
    initAccordion();
    initPropertySliders();
    initConsultantSlider();
    initTableRowHeight();
    initFormValidationControl();

    if (typeof ScrollHint !== 'undefined') {
      new ScrollHint('.js-scrollable');
    }

    console.log('Application initialized successfully');
  } catch (error) {
    console.error('Failed to initialize application:', error);
  }
});

// -----------------------------------------------
// Windowロードイベント
// -----------------------------------------------
window.addEventListener('load', () => {
  try {
    // FVスライダーは少し遅らせて初期化
    setTimeout(initFvSlider, 2000);
    
    console.log('Delayed initialization completed');
  } catch (error) {
    console.error('Failed to run delayed initialization:', error);
  }
});

// -----------------------------------------------
// デバッグ用（開発環境のみ）
// -----------------------------------------------
if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
  window.debugApp = {
    initAccordion,
    initFvSlider,
    initPropertySliders,
    initConsultantSlider,
    initHeaderVisibility,
    initSmoothScroll,
    initCtaPopup,
    Utils
  };
}
